import { useQuery } from '@tanstack/react-query';
import { Improvement } from '@/services/improvementsService';
import { API } from '@/utils/api.utils';
import api from '@/utils/api.utils';

export const useImprovements = (draftVersionId?: number) => {
  return useQuery<Improvement[], Error>({
    queryKey: ['improvements', draftVersionId],
    queryFn: async () => {
      if (!draftVersionId) return [];
      const response = await api.get(
        `${API.BASE_URL}/api/v1/improvements/?draft_version_id=${draftVersionId}`
      );
      return response.data;
    },
    enabled: !!draftVersionId, // enable when we have a draftVersionId
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });
};
